/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { NewProjectModelEndpointExcludeField } from '../models/new-project-model-endpoint-exclude-field';
import { ProjectModelEndpointExcludeField } from '../models/project-model-endpoint-exclude-field';
import { ProjectModelEndpointExcludeFieldWithRelations } from '../models/project-model-endpoint-exclude-field-with-relations';

@Injectable({
  providedIn: 'root',
})
export class ProjectModelEndpointExcludeFieldControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation projectModelEndpointExcludeFieldControllerFindById
   */
  static readonly ProjectModelEndpointExcludeFieldControllerFindByIdPath = '/project-model-endpoint-exclude-fields/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<ProjectModelEndpointExcludeFieldWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectModelEndpointExcludeFieldControllerService.ProjectModelEndpointExcludeFieldControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectModelEndpointExcludeFieldWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<ProjectModelEndpointExcludeFieldWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectModelEndpointExcludeFieldWithRelations>) => r.body as ProjectModelEndpointExcludeFieldWithRelations)
    );
  }

  /**
   * Path part for operation projectModelEndpointExcludeFieldControllerDeleteById
   */
  static readonly ProjectModelEndpointExcludeFieldControllerDeleteByIdPath = '/project-model-endpoint-exclude-fields/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectModelEndpointExcludeFieldControllerService.ProjectModelEndpointExcludeFieldControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation projectModelEndpointExcludeFieldControllerFind
   */
  static readonly ProjectModelEndpointExcludeFieldControllerFindPath = '/project-model-endpoint-exclude-fields';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ProjectModelEndpointExcludeFieldWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectModelEndpointExcludeFieldControllerService.ProjectModelEndpointExcludeFieldControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProjectModelEndpointExcludeFieldWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<ProjectModelEndpointExcludeFieldWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProjectModelEndpointExcludeFieldWithRelations>>) => r.body as Array<ProjectModelEndpointExcludeFieldWithRelations>)
    );
  }

  /**
   * Path part for operation projectModelEndpointExcludeFieldControllerCreate
   */
  static readonly ProjectModelEndpointExcludeFieldControllerCreatePath = '/project-model-endpoint-exclude-fields';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewProjectModelEndpointExcludeField
  }): Observable<StrictHttpResponse<ProjectModelEndpointExcludeField>> {

    const rb = new RequestBuilder(this.rootUrl, ProjectModelEndpointExcludeFieldControllerService.ProjectModelEndpointExcludeFieldControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectModelEndpointExcludeField>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewProjectModelEndpointExcludeField
  }): Observable<ProjectModelEndpointExcludeField> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectModelEndpointExcludeField>) => r.body as ProjectModelEndpointExcludeField)
    );
  }

}
